"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = create;
exports.generateReducerFunction = generateReducerFunction;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _lodash = _interopRequireDefault(require("lodash"));

var _memoizeResolver = _interopRequireDefault(require("./memoize-resolver"));

var _redux = require("./redux");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty2(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Generates a normal Redux reducer function that takes
 * an action and returns the new global state.
 * @param  {Function} mainReducer
 * @param  {Function} requestReducer
 * @return {Function}
 */
function generateReducerFunction() {
  var mainReducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var requestReducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  // Ensure we're passing down functions (for some reason we don't
  //  in some cases)
  if (!_lodash.default.isFunction(mainReducer)) mainReducer = _lodash.default.identity;
  if (!_lodash.default.isFunction(requestReducer)) requestReducer = _lodash.default.identity; // Run the main reducer first, then (if defined in meta) run the
  //  loading reducer AFTER the main reduces has finished

  return _lodash.default.flow(mainReducer, requestReducer);
}
/**
 * Generates a model based on the provided name
 * @param  {string}  options
 * @return {Function} Redux reducer
 */


function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var originalName = options.modelName,
      actionCreators = options.actionCreators,
      selectors = options.selectors,
      initialState = options.initialState,
      _options$namespace = options.namespace,
      namespace = _options$namespace === void 0 ? null : _options$namespace,
      _options$config = options.config,
      config = _options$config === void 0 ? {} : _options$config;

  var modelName = _lodash.default.camelCase(originalName);

  var model = (0, _reduce.default)(_lodash.default).call(_lodash.default, actionCreators, function (resultObject, method, methodName) {
    var _context, _context2, _context3, _context4;

    // Fall back to default reduceRequest behaviour if none provided.
    var reduceRequest = method.reduceRequest || {}; // Create a base action name if one is not provided.

    var actionName = method.actionName || (0, _concat.default)(_context = "".concat(modelName, "/")).call(_context, _lodash.default.toUpper(_lodash.default.snakeCase(methodName))); // NOTE: disabled from now, because of the way we clone models atm
    // if (namespace) {
    //   actionName = `${namespace}/${actionName}`;
    // }
    // If a request is passed, return a thunk.

    resultObject.actionCreators[methodName] = method.request ? (0, _redux.generateAsyncActionCreator)(actionName, method.request, resultObject.actionCreators) : (0, _redux.generateActionCreator)(actionName);

    if (_lodash.default.isFunction((0, _reduce.default)(method))) {
      resultObject.reducers[actionName] = generateReducerFunction(method.request ? _lodash.default.identity : (0, _reduce.default)(method), method.request ? reduceRequest.initial || reduceRequest : null);
    } else {
      resultObject.reducers[actionName] = generateReducerFunction((0, _reduce.default)(method).initial, method.request ? reduceRequest.initial : null);
    }

    var successName = (0, _concat.default)(_context2 = "".concat(actionName)).call(_context2, _redux.ASYNC_SUCCESS_SUFFIX);
    var failureName = (0, _concat.default)(_context3 = "".concat(actionName)).call(_context3, _redux.ASYNC_FAILURE_SUFFIX);
    var cancelName = (0, _concat.default)(_context4 = "".concat(actionName)).call(_context4, _redux.ASYNC_CANCEL_SUFFIX);

    if (method.request) {
      resultObject.reducers[successName] = generateReducerFunction((0, _reduce.default)(method).success || (0, _reduce.default)(method), reduceRequest.success);
      resultObject.reducers[failureName] = generateReducerFunction((0, _reduce.default)(method).failure, reduceRequest.failure);
      resultObject.reducers[cancelName] = generateReducerFunction((0, _reduce.default)(method).cancel || (0, _reduce.default)(method).failure, reduceRequest.failure);
    }

    return resultObject;
  }, {
    reducers: {},
    actionCreators: {}
  });
  var reducer = (0, _redux.createReducer)(initialState, model.reducers); // Generates an object of selectors. Can be easily fed into react-redux as
  //  a mapStateToProps function.

  var selectorFunction = function selectorFunction(state, props) {
    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _lodash.default.mapValues(selectors, function (selector) {
      var _context5;

      return selector(state, props, _objectSpread({
        localState: _lodash.default.get(state, namespace ? (0, _concat.default)(_context5 = "".concat(namespace, ".")).call(_context5, modelName) : modelName)
      }, meta));
    });
  };

  var memSelectorFunction = _lodash.default.memoize(selectorFunction, (0, _memoizeResolver.default)());

  function assignReadonlyPropery(targetObject, key, value) {
    (0, _defineProperty3.default)(targetObject, key, {
      value: value,
      writable: false,
      enumerable: false
    });
  }

  assignReadonlyPropery(reducer, 'modelName', modelName);
  assignReadonlyPropery(reducer, 'actionCreators', model.actionCreators);
  assignReadonlyPropery(reducer, 'reducers', model.reducers);
  assignReadonlyPropery(reducer, 'selectors', memSelectorFunction);
  assignReadonlyPropery(reducer, 'config', config);
  assignReadonlyPropery(reducer, 'clone', function (customOptions) {
    return create(_objectSpread(_objectSpread({}, options || {}), customOptions || {}));
  });
  return reducer;
}